import {
  ManagerCompanyInvitationActions,
  ManagerCompanyInvitationActionTypes
} from '@appStore/managers/actions/manager-company-invitation.actions';
import { UserInvitation } from '@model';

export interface State {
  loading: boolean;
  loaded: boolean;
  data: UserInvitation[];
  invitation: UserInvitation;
  creating: boolean;
  created: boolean;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  data: [],
  invitation: null,
  creating: false,
  created: false
};

export function reducer(state = initialState, action: ManagerCompanyInvitationActions): State {
  switch (action.type) {
    case ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitations:
      return { ...state, creating: true, created: false };

    case ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitationsSuccess:
      const addedData = action.payload.filter(x => state.data.every(y => y.id !== x.id));
      return {
        ...state,
        creating: false,
        created: true,
        data:
          action.payload === null
            ? []
            : addedData.some(d => d.existingUser)
            ? state.data
            : [...state.data, ...addedData]
      };
    case ManagerCompanyInvitationActionTypes.BulkCreateManagerCompanyInvitationsFail:
      return {
        ...state,
        creating: false,
        created: false,
        data: []
      };

    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadData:
      return { ...state, loading: true, loaded: false };

    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadSuccess:
      return { ...state, data: action.payload, loading: false, loaded: true };

    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationsLoadFail:
      return { ...state, data: [], loading: false, loaded: false };

    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationRemoveSuccess:
      const oldItem = action.payload;
      const aggregatedUniqueKeyOld = oldItem.aggregatedUniqueKey;
      if (aggregatedUniqueKeyOld) {
        return { ...state, loaded: true, loading: false,
          data: state.data.filter(item => item.aggregatedUniqueKey !== oldItem.aggregatedUniqueKey) };
      } else {
        return { ...state, loaded: true, loading: false, data: state.data.filter(item => item.id !== oldItem.id) };
      }
  
    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationReSendSuccess:
      const updatedItems = action.payload;
      let aggregatedUniqueKeyUpdated = updatedItems[0].aggregatedUniqueKey;

      if (aggregatedUniqueKeyUpdated) {
      return {
        ...state,
        loaded: true,
        loading: false,
        data: state.data.map(item => {
          let updatedItem = updatedItems.find(c => c.id === item.id);
          return updatedItem ? updatedItem : item;
        })
      };
    } else {
      return {
        ...state,
        loaded: true,
        loading: false,
        data: state.data.map(item => {
          let updatedItem = updatedItems.find(c => c.aggregatedUniqueKey === item.aggregatedUniqueKey);
          return updatedItem ? updatedItem : item;
        })
      };
    }

    case ManagerCompanyInvitationActionTypes.ManagerCompanyInvitationUpdate:
      const updatedInvitation = action.payload;

      return {
        ...state,
        data: state.data.map(item => (item.id === updatedInvitation.id ? updatedInvitation : item))
      };
  }
  return state;
}

export const getManagerCompanyInvitationCreated = (state: State) => state.created;

export const getManagerCompanyInvitations = (state: State) => state.data;
export const getManagerCompanyInvitationsLoading = (state: State) => state.loading;
export const getManagerCompanyInvitationsLoaded = (state: State) => state.loaded;
